import { createSelector } from "reselect";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";
import { isDefined, memoize, uniqueByKey } from "@ls/js-utils";
import SummaryType from "state/selections/Constants/SummaryType";

export const selectData = (summaryType) => (state) =>
  state[scope]["data"][summaryType];
export const selectFetchingData = (summaryType) => (state) =>
  state[scope]["fetchingData"][summaryType];
export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectRowsMap = createSelector(
  selectDefinitions(SelectionState.COMMITTED),
  selectData(SummaryType.ABSOLUTE),
  selectData(SummaryType.RELATIVE),
  (issueCountDefinitions, absData, relData) => {
    const entityRowsMap = {};
    const toRowsMap = (groupingData, definitions) => {
      if (groupingData?.root?.entitySummaries && definitions?.length) {
        groupingData.root.entitySummaries.forEach((entitySummary) => {
          const { entityId /*relative todo*/ } =
            entitySummary.entityResultMetaData;
          const { issueCounts = [] } = entitySummary;

          definitions.forEach((issueCountDef) => {
            const issueCountObj = issueCounts.find(
              (issueCountObj) =>
                issueCountObj.type === issueCountDef.issueCountType
            );
            if (!isDefined(entityRowsMap[entityId])) {
              entityRowsMap[entityId] = {};
            }
            if (issueCountObj) {
              const { issueCountType, summary } = issueCountDef;
              entityRowsMap[entityId][
                `${scope}, ${issueCountType}, ${summary}`
              ] = issueCountObj.issueCount;
            }
          });
        });
      }

      return entityRowsMap;
    };

    const absRowsMap = toRowsMap(
      absData,
      issueCountDefinitions.filter(
        ({ summary }) => summary === SummaryType.ABSOLUTE
      )
    );
    const relRowsMap = toRowsMap(
      relData,
      issueCountDefinitions.filter(
        ({ summary }) => summary === SummaryType.RELATIVE
      )
    );

    const result = { ...absRowsMap };
    Object.entries(relRowsMap).forEach(([entityId, relFields]) => {
      if (!result[entityId]) {
        result[entityId] = {};
      }
      result[entityId] = {
        ...result[entityId],
        ...relFields,
      };
    });

    return result;
  }
);
